module.exports = __webpack_public_path__ + "img/cercas2.88db25e6.jpeg";